export const _isDescendant = (parent, child) => {
  let node = child.parentNode
  while (node != null) {
    if (node === parent) {
      return true
    }
    node = node.parentNode
  }
  return false
}

export const _formatNumber = (num = 0) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export const _multipleByScale = (num, scale = 1) => {
  const isDemoMode = process.env.VUE_APP_MODE === 'demo'
  if (!isDemoMode) return num
  return num * scale
}

export const _updateArrayItem = (array, key, value, newItem) => {
  const index = array && array.findIndex(i => i[key] === value)
  array.splice(index, 1, newItem)
  return array
}

export const validIpAddress = (customIp) => {
  const reg = new RegExp('^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$')
  return reg.test(customIp)
}
